module.exports = __webpack_public_path__ + "static/media/Algoquant-logo.7cfb2c53.png";